import { Observable } from 'rxjs';
import { OrdersModelKeys } from '../models/orders.model';

export abstract class OrdersRepository {
    abstract getOrders<T>(config: OrdersModelKeys): Observable<T>;
    abstract getCardPDF<T>(config: string): Observable<T>;
}
